import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Collapse,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSaveAnamnesisCatalog } from './hooks/useSaveAnamnesisCatalog';

export default function AnamnesisCatalogFormModal({ open, onClose, onSave, question }) {
  const navigate = useNavigate();
  const { save: saveAnamnesisCatalog } = useSaveAnamnesisCatalog();
  const [formQuestion, setFormQuestion] = useState('');
  const [formOrder, setFormOrder] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setFormQuestion(question?.description ?? '');
      setFormOrder(question?.order != null ? String(question.order) : '');
      setError('');
    }
  }, [open, question]);

  const save = () => {
    if (!formQuestion.trim()) return;

    const payload = {
      description: formQuestion,
      order: formOrder !== '' ? Number(formOrder) : null,
    };
    saveAnamnesisCatalog(question ? question.id : null, payload)
      .then(() => {
        onSave();
        onClose();
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate('/expired-session');
        } else {
          setError(err.response?.data ?? 'Erro ao salvar pergunta.');
        }
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        {question ? 'Editar Pergunta' : 'Nova Pergunta'}
      </DialogTitle>
      <DialogContent>
        <Collapse in={!!error} sx={{ mb: 1 }}>
          <Alert severity="error" onClose={() => setError('')}>
            {error}
          </Alert>
        </Collapse>
        <TextField
          autoFocus
          label="Pergunta"
          fullWidth
          multiline
          rows={3}
          value={formQuestion}
          onChange={(e) => setFormQuestion(e.target.value)}
          sx={{ mt: 1 }}
        />
        <TextField
          label="Ordem"
          fullWidth
          type="number"
          inputProps={{ min: 1 }}
          value={formOrder}
          onChange={(e) => setFormOrder(e.target.value)}
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={save} disabled={!formQuestion.trim()}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AnamnesisCatalogFormModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  question: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string,
    order: PropTypes.number,
  }),
};

AnamnesisCatalogFormModal.defaultProps = {
  question: null,
};
